import React, { useState } from 'react';
import { Checkbox } from '@moda/om';
import { noop } from '@moda/portal-stanchions';
import { ContinueAsGuestButton } from './ContinueAsGuestButton';
import { CheckoutSocialAuthButtons } from './CheckoutSocialAuthButtons';
import { PasswordlessAuthentication } from './PasswordlessAuthentication';

import './Authentication.scss';
import './CheckoutAuthentication.scss';

export const PasswordlessCheckoutAuthentication: React.FC = () => {
  const [emailListOptedIn, setEmailListOptedIn] = useState(true);

  return (
    <div className="CheckoutAuthentication">
      <div className="CheckoutAuthentication__section">
        <PasswordlessAuthentication
          onAuth={noop}
          otpFooter={({ email }) => (
            <ContinueAsGuestButton email={email} onAuth={noop} optedIn={emailListOptedIn} />
          )}
          registrationDefaultEmailList={emailListOptedIn}
          requestFieldsFooter={
            <div className="Authentication__checkboxes">
              <Checkbox
                checked={emailListOptedIn}
                className="Authentication__checkbox"
                data-testid="guestEmailList"
                onChange={() => setEmailListOptedIn(previous => !previous)}
                type="checkbox"
              >
                Sign me up for special access and updates
              </Checkbox>
            </div>
          }
          requestTitle="Welcome to Checkout"
          requestMessage="Enter your email to sign in for faster checkout, order tracking, and save favorites, or continue as a guest."
          requestFooter={<CheckoutSocialAuthButtons theme="black-and-white" />}
          showCancelButton={false}
          showSocialAuth={false}
        />
      </div>
    </div>
  );
};
